import React, { FC } from 'react';
import NextLink from 'next/link';
import { t } from '@whitesharx/starfall-frontend-ttranslate';
import { Link, Icon, Text } from '@whitesharx/starfall-frontend-ui-kit';
import { UserInfo as UserInfoFrame } from '@whitesharx/starfall-frontend-core';

import { userIconContainerStyles, contentContainerStyles } from './styles.css';

export type UserInfoProps = {
  withoutProfileLink?: boolean;
};

const UserInfo: FC<UserInfoProps> = ({ withoutProfileLink }) => {
  const ProfileLink = withoutProfileLink ? undefined : (
    <NextLink href="/profile" passHref>
      <Link>
        <div className={contentContainerStyles}>
          <div className={userIconContainerStyles}>
            <Icon color="purple100" name="player" size="16" />
          </div>
          <Text fontSize="12px" color="purple100">
            {t('view-profile')}
          </Text>
        </div>
      </Link>
    </NextLink>
  );

  return <UserInfoFrame ProfileLink={ProfileLink} />;
};

export default UserInfo;
